import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { languageActions, languageSelectors } from '../../../redux/language';
import classNames from 'classnames';
import { Disclosure } from '@headlessui/react';
import Icon from '../../../components/envago/Icon/Icon';
import { useTranslation } from 'react-i18next';
import { getMenuClasses } from '../../MainScreen/NavigationBar/NavigationBar';

interface LanguageButtonProps {
    forceContrast?: boolean;
    menuButton?: boolean;
    onClick?: () => void;
}

const LanguageButton = ({ forceContrast, menuButton = false, onClick }: LanguageButtonProps) => {
    const { t } = useTranslation();

    const nextLanguage = useSelector(languageSelectors.getNextLanguage);
    const enabledLanguages = useSelector(languageSelectors.getEnabledLanguages);
    const dispatch = useDispatch();

    const handleClick = () => {
        dispatch(languageActions.selectLanguage(nextLanguage?.name || ''));

        if (onClick) {
            onClick();
        }
    };

    if (!enabledLanguages || enabledLanguages.length < 2) return null;

    if (menuButton) {
        return (
            <Disclosure.Button as={Fragment}>
                <a
                    key={'language-button'}
                    href={'language-button'}
                    aria-label={`Sprache zu ${nextLanguage?.readableName} wechseln`}
                    role={'menuitem'}
                    onClick={(e) => {
                        e.preventDefault();

                        handleClick();
                    }}
                    className={getMenuClasses(false, true)}
                >
                    <div className={'flex gap-2 justify-center '}>
                        <Icon
                            path={Icon.Path.mdiTranslate}
                            size={'1.5em'}
                            aria={{
                                'aria-hidden': true,
                            }}
                        />
                        <span> {t('common.changeLanguageTo', { language: nextLanguage?.readableName })}</span>
                    </div>
                </a>
            </Disclosure.Button>
        );
    }

    return (
        <button
            role={'menuitem'}
            onClick={handleClick}
            aria-label={`Sprache zu ${nextLanguage?.readableName} wechseln`}
            className={classNames(
                'w-8 h-8 cursor-pointer text-center text-menu-item-text bg-menu-item-bg hover:bg-menu-item-bg-hover hover:text-menu-item-text-hover  align-middle justify-center items-center flex text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white',
                { 'text-gray-900': forceContrast },
            )}
        >
            <span className={'h-6 w-6 m-1 leading-relaxed'}>{nextLanguage?.readableName}</span>
        </button>
    );
};

export default LanguageButton;
